import { Badge } from '@chakra-ui/react';
import { useMemo } from 'react';

type QuotingTagType =
    | 'pre-order'
    | 'on-site'
    | 'auto-order'
    | 'expedited'
    | 'quote-only'
    | 'potential-total'
    | 'oem-endorsement'
    | 'dealer-referral';

interface OrderTagProps {
    tag: QuotingTagType;
    text: string;
}

const QuotingTag = ({ tag, text }: OrderTagProps) => {

    const colorScheme = useMemo(() => {
        switch (tag) {
            case 'on-site': return 'teal';
            case 'pre-order': return 'yellow';
            case 'auto-order': return 'purple';
            case 'expedited': return 'red';
            case 'quote-only': return 'blue';
            case 'potential-total': return 'yellow';
            case 'oem-endorsement': return 'cyan';
            case 'dealer-referral': return 'pink';
            default: return 'gray';
        }
    }, [tag]);

    return (
        <Badge
            colorScheme={colorScheme}
            variant="subtle"
            p={1}
            fontSize="xs"
            fontWeight="normal"
            borderRadius="md"
        >
            {text}
        </Badge>
    );
};

export default QuotingTag;